export const buttonGroupItems = [
  { label: 'Policies', value: 'policies' },
  { label: 'Entity Types', value: 'entityTypes' },
];
